import { Field, Label } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { ERROR_PROPS, MONTHS_OPTIONS } from './constants';
import useYearsAtAddressFields from './useYearsAtAddressFields';

import { AddressFieldType } from '..';

export interface YearsAtAddressFieldsProps {
  addressType: AddressFieldType;
}

const YearsAtAddressFields: React.FunctionComponent<YearsAtAddressFieldsProps> =
  function ({ addressType }) {
    const {
      monthsName,
      yearsName,
      yearsOptions,
      error,
      validation,
      baseWidget: BaseWidget,
    } = useYearsAtAddressFields(addressType);
    return (
      <div className="flex flex-col w-full text-left">
        <Label label="When did you move into this address?" />
        <div className="grid grid-cols-2 gap-x-3 md:gap-x-4 w-full">
          <Field.Select
            options={MONTHS_OPTIONS}
            name={monthsName}
            placeholder="Month"
          />

          <Field.Select
            options={yearsOptions}
            name={yearsName}
            placeholder="Year"
          />
        </div>
        {error && <Text text={error} className={ERROR_PROPS.className} />}
        <div className="hidden">
          <BaseWidget validation={validation} />
        </div>
      </div>
    );
  };

export default YearsAtAddressFields;
